// Item code options for invoice lines
export const ITEM_CODE_OPTIONS = [
    { value: 'CDR', label: 'CDR' },
    { value: 'Company', label: 'Company' },
    { value: 'NumberBlock', label: 'Number Block' },
    { value: 'NumberBlockPorting', label: 'Number Block Porting' },
    { value: 'RGS', label: 'RGS' },
    { value: 'TeamsUser', label: 'Teams User' },
    { value: 'Trunk', label: 'Trunk' },
];

// Initial table state with one empty row
export const initTableState = [
    {
        id: 0,
        itemCode: '',
        quantity: '',
        unitPrice: '',
        description: '',
    },
];

// Validation helper to check if a row is complete (all required fields filled)
export const isRowComplete = (row) => {
    return (
        row.itemCode &&
        row.quantity !== '' &&
        row.quantity !== null &&
        row.unitPrice !== '' &&
        row.unitPrice !== null &&
        row.description
    );
};

// Validation helper to check if a row is empty (no fields filled)
export const isRowEmpty = (row) => {
    return (
        !row.itemCode &&
        (row.quantity === '' || row.quantity === null) &&
        (row.unitPrice === '' || row.unitPrice === null) &&
        !row.description
    );
};

// Calculate line total
export const calculateLineTotal = (quantity, unitPrice) => {
    const qty = parseFloat(quantity) || 0;
    const price = parseFloat(unitPrice) || 0;
    return Math.round(qty * price * 1000000) / 1000000; // 6 decimal places
};

const normalizeDescription = (value) => (value || '').trim().toLowerCase();

// Descriptions must be unique on the invoice — the backend enforces this with
// a unique index and silently rejects duplicates (#1941), so duplicates need
// to be caught here, both against other new rows and existing invoice lines.
export const getDuplicateRowIds = (rows, existingLines = []) => {
    const existingDescriptions = new Set(
        existingLines
            .map((line) => normalizeDescription(line.description))
            .filter(Boolean),
    );

    const countByDescription = {};
    rows.forEach((row) => {
        const description = normalizeDescription(row.description);
        if (!description) return;
        countByDescription[description] =
            (countByDescription[description] || 0) + 1;
    });

    const duplicateRowIds = new Set();
    rows.forEach((row) => {
        const description = normalizeDescription(row.description);
        if (!description) return;
        if (
            countByDescription[description] > 1 ||
            existingDescriptions.has(description)
        ) {
            duplicateRowIds.add(row.id);
        }
    });

    return duplicateRowIds;
};
